import { Popover, PopoverContent, PopoverTrigger, Button, Link } from "@nextui-org/react";

import { FiShare } from "react-icons/fi";
import { useCallback, useMemo ,useState} from "react";
import { useAccount } from "wagmi";
import copy from "copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { shortAddress } from "../../../utils/address";
import  CopySuccessPopup  from "../../../components/CopySuccessPopup";
export const Share = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { t } = useTranslation()
  const { address } = useAccount()

  const link = useMemo(() => {
    return `${window.location.protocol}//${window.location.host}/profile?ref=${address}`
  }, [address])
  const linkshow = useMemo(() => {
    return `${window.location.protocol}//${window.location.host}/profile?ref=${shortAddress(address)}`
  }, [address])
  const onCopy = useCallback(() => {
    copy(link)
    setIsPopupOpen(true);
  }, [link])

  return (

    // <div className="flex align-center justify-between w-max-content w-full">
    //   <Link href="#" className="text-gray-600 underline px-2 truncate max-w-fit	">
    //     {linkshow}
    //   </Link>
    //   <Button className="bg-button text-black font-semibold text-xs h-8" onPress={onCopy}>邀请返佣</Button>
    // </div>

     <div className="flex align-center justify-between w-max-content w-full">
       <Link href="#" className="text-gray-600 underline px-2 truncate max-w-fit	">
         {linkshow}
       </Link>
       <Button className="bg-button text-black font-semibold text-xs h-8" onPress={onCopy}>邀请返佣</Button>
        <CopySuccessPopup
        message="复制成功！"
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
     </div>
     
  )
}

// 邀请质押可得10%奖励